module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Expand All":"Раскрыть все","top":"Топ-{number}","All":"Все","monthly":"в месяц","hide":"скрыть"},"en":{"top":"Top-{number}"}}')
  delete Component.options._Ctor
}
